import { PASSWORD_POLICY_MESSAGE } from '@design/forms/form-validation';

export interface ResetPasswordModalContent {
  title: string;
  message: string;
}

const defaultInvalidTokenModal: ResetPasswordModalContent = {
  title: 'Invalid token',
  message: 'The reset password token is no longer valid.<br> You may wish to restart resetting your password.'
};

export function getResetPassword400Modal(errorBody: { status?: string; message?: string } | undefined): ResetPasswordModalContent {
  switch (errorBody?.status) {
    case 'TokenExpired':
      return {
        title: 'Expired Link',
        message: 'The reset password link has expired.<br> You may wish to restart resetting your password.'
      };
    case 'TokenSpent':
      return {
        title: 'Link already used',
        message: 'The reset password link has already been used.<br> You may wish to restart resetting your password.'
      };
    case 'PasswordNotValid':
      return {
        title: 'Password not valid',
        message: errorBody?.message ?? PASSWORD_POLICY_MESSAGE
      };
    // DOB verification statuses returned when resetting password after an email change
    case 'DateOfBirthRequired':
      return {
        title: 'Date of birth required',
        message: 'Please enter your date of birth to continue.'
      };
    case 'DateOfBirthMismatch':
      return {
        title: 'Date of birth does not match',
        message: 'The date of birth you entered does not match our records. Please check and try again.'
      };
    case 'DateOfBirthVerificationNotPossible':
      return {
        title: 'Unable to verify date of birth',
        message: 'We cannot verify your date of birth at this time. Please contact your administrator.'
      };
    case 'DateOfBirthAttemptsExceeded':
      return {
        title: 'Too many attempts',
        message: 'The maximum number of date-of-birth attempts has been reached. Please contact your administrator.'
      };
    default:
      return defaultInvalidTokenModal;
  }
}
